import { SimpleGrid } from '@chakra-ui/react';
import { CustomFieldEntityEnum, IInvoiceRespSchema } from '@monetize/types/app';
import { formatCurrency, toDateShort } from '@monetize/utils/core';
import { ROUTES } from '../../../constants';
import { InvoiceStatusEnumDisplay } from '../../../constants/invoice';
import { CustomFieldDataForm } from '../../CustomFields/CustomFieldDataForm';
import { MFormFieldReadOnly } from '../MFormFieldReadOnly';
import { LookupTriggerContent } from './LookupTriggerContent';
import { RecordLookupPopover } from './RecordLookupPopover';
import { RecordLookupPopoverHeader } from './RecordLookupPopoverHeader';

export interface InvoiceLookupPopoverProps {
  value: string;
  displayLabel?: string;
}

export function InvoiceLookupPopover({
  value,
  displayLabel,
}: InvoiceLookupPopoverProps) {
  if (!value) {
    return null;
  }
  return (
    <RecordLookupPopover
      recordId={value}
      endpoint={`/api/invoices/${value}`}
      buttonProps={{ lineClamp: 3 }}
      renderRecord={(record) => {
        const invoice = record as IInvoiceRespSchema;
        const recordName = invoice.invoiceNumber ?? invoice.id ?? value;
        return (
          <>
            <RecordLookupPopoverHeader
              recordId={invoice.id}
              href={ROUTES.getInvoiceDetailRoute(invoice.id)}
              recordName={recordName}
              displayStatus={InvoiceStatusEnumDisplay[invoice.status]}
            />

            <SimpleGrid columns={2} gap={2} mt={2}>
              <MFormFieldReadOnly label="Due Date">
                {invoice.dueDate ? toDateShort(invoice.dueDate) : '-'}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Sent Date">
                {invoice.lastSent ? toDateShort(invoice.lastSent) : 'Not Sent'}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Amount">
                {formatCurrency(invoice.amount, {
                  currency: invoice.currency,
                })}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Amount Due">
                {formatCurrency(invoice.amountDue, {
                  currency: invoice.currency,
                })}
              </MFormFieldReadOnly>
            </SimpleGrid>
            <CustomFieldDataForm
              entity={CustomFieldEntityEnum.INVOICE}
              value={invoice.customFields ?? {}}
              isReadOnly
              variant="readonly"
              setValue={() => {}}
              fieldColSpan={6}
              mode="modal"
            />
          </>
        );
      }}
    >
      <LookupTriggerContent displayLabel={displayLabel} value={value} />
    </RecordLookupPopover>
  );
}
